export default "__VITE_ASSET__RfhIJPGH__"